module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAE0lEQVR42mNgQAK75/79D8LIYgBsyQap6Fn4ewAAAABJRU5ErkJggg=="